<div class="keyword-proverb-box">

  <article class="keyword">
    <div class="proverb {{ selected ? 'on' : '' }}"
         *ngIf="!selected"
         [innerHTML]="detail.proverb2 | resize | keepHtml"></div>
    <app-link-content class="proverb {{ selected ? 'on' : '' }}"
                      *ngIf="selected"
                      [content]="detail.proverb3 | resize"></app-link-content>

    <!-- 속담은 책갈피 기능을 제공하지 않는다. 나중에 복구할 수 있으므로 제거하지 않고 주석으로 유지한다.
    <div class="detail-menu-btn">
      <a class="detail-menu-btn bookmark-btn {{ getBmCss(detail) }}"
         (click)="ToggleBookmark($event, detail)"></a>
    </div>
    -->

  </article>

</div>

<div class="keyword-bottom-box">
  <div class="txt-box {{ selected ? 'on' : '' }}"
       *ngIf="!selected">{{ detail.meaning2 }}</div>
  <app-link-content class="txt-box {{ selected ? 'on' : '' }}"
                    *ngIf="selected"
                    [content]="detail.meaning3 | resize"></app-link-content>
</div>
